import axios from 'lib/axios'

export const uploadEmployeeDetails = (newValue) => {
  return axios.post('admin/payroll/bulk-import', newValue)
}

export const storeEmployeeDetails = (data) => {
  return axios.post('admin/payroll/upload-bulk-import', data)
}

export const downloadEmployeeDetails = async () => {
  const response = await axios.get('admin/payroll/bulk-export', { responseType: 'blob' })
  return response
}
